import request from "orcrist-request";
import * as Utils from "../utils/utils";

let sources = Utils.getSources();
let saleChannelId = Utils.getSaleChannelId();
//微信静默登录
export const queryUserIdFetch = (openid: string) => {
  return () => {
    let params = {
      code: "",
      loginType: "3",
      loginMode: 1,
      phone: "",
      wechatCode: "",
      source: sources,
      marketInfo: saleChannelId,
      extId: openid,
    };

    return request("/api/usercenter/login", {
      method: "POST",
      body: params,
    });
  };
};

//请求验证码接口
export const sendCodeFetch = (phoneNumber: string) => {
  return () => {
    let params = {
      receiver: phoneNumber,
      codeType: "1",
      loginMode: 1,
      source: sources,
    };
    return request("/api/usercenter/login/send_code", {
      body: params,
      method: "post",
    });
  };
};

//请求验证码接口
export const verifyCodeFetch = (phoneNumber: string, refreshCode: string) => {
  return () => {
    let params = {
      receiver: phoneNumber,
      refreshCode,
      codeType: "1",
      loginMode: 1,
      source: sources,
    };
    return request("/api/usercenter/login/send_code", {
      body: params,
      method: "post",
    });
  };
};

//请求图形验证码
export const graphicCodeFetch = (phoneNumber: string) => {
  return () => {
    let options = {
      body: {
        receiver: phoneNumber,
        codeType: "1",
        loginMode: 1,
        source: sources,
      },
      method: "post",
    };

    return request("/api/usercenter/login/refresh_code", options);
  };
};

//登录
export const loginFetch = (phoneNumber: string, numberCode: string) => {
  return () => {
    let options = {
      body: {
        code: numberCode,
        loginType: "7",
        loginMode: 1,
        phone: phoneNumber,
        source: sources,
        wechatCode: sessionStorage.getItem("SP_WX_CODE") || "",
        extId: sessionStorage.getItem("SP_WX_OPENID") || "",
        marketInfo: saleChannelId,
      },
      method: "post",
    };
    return request("/api/usercenter/login", options);
  };
};

//用户详细信息（包含昵称和头像）；接口：http://yapi.medbanks-inc.com/project/297/interface/api/16909
// export const userDetailFetch = (userId: string) => {
//   return () => {
//     let options = {
//       body: {
//         source: sources,
//         userId
//       },
//       method: "post",
//     };
//     return request("/api/usercenter/userinfo/detail", options);
//   };
// };
